export default __webpack_public_path__ + "static/img1-3a686db57bde3de127077777054759f2.png";